module.exports = __webpack_public_path__ + "static/media/Logo.a4249e9d.svg";